<template>
	<div>
		<pui-datatable 
			:modelName="modelName" ></pui-datatable>
	</div>
</template>

<script>

export default {
	name: 'mimdg-revision-grid',
	data() {
		return {
			modelName: 'mimdgrevision',
		}
	}
}
</script>
